import { styled } from "@mui/material";

export const ShareViewType = {
  FitWindow: "fit",
  OriginalSize: "original",
};

export const ShareViewContainer = styled("div", {
  shouldForwardProp: (prop) =>
    prop !== "isRecieveSharing" && prop !== "viewType", // Evitar pasar esta prop al DOM
})(({ theme, isRecieveSharing, viewType }) => ({
  display: isRecieveSharing ? "flex" : "none",
  flexGrow: 1,
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  minWidth: 0,
  width: "100%",
  ...(isRecieveSharing && viewType === ShareViewType.OriginalSize
    ? { display: "block" }
    : {}),
}));

export const ShareViewViewport = styled("div", {
  shouldForwardProp: (prop) => prop !== "viewType", // Evitar pasar esta prop al DOM
})(({ theme, viewType }) => ({
  maxWidth: "100%",
  ...(viewType === ShareViewType.OriginalSize
    ? { maxWidth: "initial", cursor: "move" }
    : {}),
  "& .share-view-canvas": {
    height: "100%",
  },
}));
